import { Observable, of } from 'rxjs';
import { map, tap, switchMap, take } from 'rxjs/operators';

import { IPrivilege } from '../interfaces/models';
import { PageConfig, Endpoint, CentralApis } from '../interfaces/internal';
import { PageTitles } from '../interfaces/types';
import { Page } from './page';
import { Result } from '../interfaces/helpers';
import { Privilege } from '../models/privilege';

export class PrivilegePage extends Page<Privilege> {
  constructor({ endpoint }: Endpoint, config: PageConfig) {
    const url = (endpoint as CentralApis).iam + 'privilege';
    super(url, PageTitles.privilege, config);
  }

  get actions(): string[] {
    return [];
  }

  fetch(queryString?): Observable<Result<Privilege>> {
    return this.getItems(queryString).pipe(
      tap(({ items }) => {
        this.pageItems.next(items);
      })
    );
  }

  fetchById(id: string): Observable<Privilege> {
    return this.getItem(id).pipe(
      map((data: IPrivilege) => this.createFromDTO(data))
    );
  }

  update(item: IPrivilege): Observable<Privilege> {
    let updatedRoles: IPrivilege[];

    return this.items.pipe(
      take(1),
      switchMap((privileges) => {
        if (!privileges || privileges.length <= 0) {
          return this.fetch().pipe(map(({ items }) => items));
        } else {
          return of(privileges);
        }
      }),
      switchMap((privileges) => {
        const roleIndex = privileges.findIndex((i) => i.id === item.id);
        updatedRoles = [...privileges];
        const oldRole = updatedRoles[roleIndex];
        updatedRoles[roleIndex] = this.createFromDTO({
          ...item,
          id: oldRole.id,
        });
        return this.updateItems(updatedRoles[roleIndex]);
      }),
      tap(() => {
        this.pageItems.next(updatedRoles);
      })
    );
  }

  createFromDTO(item): Privilege {
    return new Privilege({ ...item, functionName: item.function });
  }
}
